<div class="overlay" *ngIf="ShowAddNewPartner;"></div>

<div class="AddNewPartnerContainer animated fadeInDown" *ngIf="ShowAddNewPartner == true;">
    <div class="AddNewPartnerContainerTitle">
      {{'AddNewPartner' | translate}}
    </div>
    <div class="AddNewPartnerContainerClose" (click)="ShowAddNewPartner = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="AddNewPartnerContainerBody">

      <p class="NewTextBoxContainerTitle">{{'Name' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
        <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ContactCompany" matInput>
      </div>

      <p class="NewTextBoxContainerTitle">{{'Contact' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
        <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ContactPerson" matInput>
      </div>

      <p class="NewTextBoxContainerTitle">{{'VATNumber' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
        <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.VATNumber" matInput>
      </div>

      <div class="B2BBodyTopSearchContainer" style="margin: 0;" *ngIf="this.NewPartnerAddress != null && this.NewPartnerAddress?.ID != null && this.Countries?.length > 0;">
        <p class="NewTextBoxContainerTitle">{{'SearchCountries' | translate}}</p>
        <div class="NewTextBoxContainer" style="width: 90%;">
          <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
          <div class="NewTextBoxImageContainer" *ngIf="this.NewPartnerAddress?.Country?.FlagURL?.length > 0;">
            <img [src]="this.NewPartnerAddress.Country.FlagURL">
          </div>
          <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Country.Name" matInput (ngModelChange)="this.countryTermUpdate.next($event)" (click)="InitializeNewAddressCountrySearch();">
          <i class="material-icons" *ngIf="!(this.NewPartnerAddress.Country.Name?.length > 0) && !loadingCountry;">search</i>
          <i class="material-icons" style="color:red;" *ngIf="this.NewPartnerAddress.Country.Name?.length > 0 && !loadingCountry;" (click)="DeselectNewAddressCountry();">close</i>
        
          <div class="CentralSearchResultsContainer" *ngIf="this.FilteredCountries?.length > 0;">
            <div *ngFor="let c of this.FilteredCountries;" class="PartnersSearchResultText" (click)="SelectNewPartnerAddressCountry(c);">
                <div class="FilteredCountriesImageContainer">
                  <img [src]="c.FlagURL">
                </div>
                <div class="FilteredCountriesName">{{c.Name}}</div>
            </div>
          </div>
        </div>
      </div>

      <p class="NewTextBoxContainerTitle">{{'StateProvince' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
          <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.State" matInput>
      </div>

      <p class="NewTextBoxContainerTitle">{{'City' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
          <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.City" matInput>
      </div>

      <p class="NewTextBoxContainerTitle">{{'Address' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
          <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.AddressLine" matInput>
      </div>

      <p class="NewTextBoxContainerTitle">{{'ZipCode' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
          <input (input)="ProofNewPartnerAddress();" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.ZipCode" matInput>
      </div>

      <p class="NewTextBoxContainerTitle">{{'Email' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
          <input (input)="ProofNewPartnerAddress();" disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Email" matInput>
      </div>

      <p class="NewTextBoxContainerTitle">{{'Telephone' | translate}}</p>
      <div class="NewTextBoxContainer" style="width: 90%;">
          <input (input)="ProofNewPartnerAddress();" disabled="false" type="text" class="NewTextBox" [(ngModel)]="this.NewPartnerAddress.Phone" matInput>
      </div>

    </div>

    <div class="AddNewPartnerContainerCommands">
      <div class="SelectedOption" style="margin-left: 5%;margin-top: 25px;" *ngIf="AddNewPartnerValid == true && LoadingAddNewPartnerFromShippingAddress == false;" (click)="AddNewPartnerFromShippingAddress();">
        <i class="material-icons">check</i>
        <span>{{'AddNewPartner' | translate}}</span>
      </div>

      <div class="SelectedOptionNotValid" style="margin-left: 5%;margin-top: 25px;" *ngIf="AddNewPartnerValid == false;">
        <i class="material-icons">close</i>
        <span>{{'AddNewPartner' | translate}}</span>
      </div>

      <div class="SelectedOption" style="margin-left: 5%;margin-top: 25px;background: #ddd;color: #aaa;" *ngIf="AddNewPartnerValid == true && LoadingAddNewPartnerFromShippingAddress == true;">
        <i class="material-icons">check</i>
        <span>{{'AddNewPartner' | translate}}</span>
      </div>
    </div>
</div>

<div class="ShippingMainContent">
    <div class="HalfContentTitle">
        <p>{{'NewOC' | translate}}</p>
    </div>

    <div class="MainSearchesContainer">

        <div class="HalfContent" style="width: 45%;">
            <div class="B2BBodyTopSearchContainer" style="margin: 0;">
                <p class="NewTextBoxContainerTitle">{{'SearchPartners' | translate}}</p>
                <div class="NewTextBoxContainer">
                  <mat-spinner *ngIf="loadingShipment" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
                  <input type="text" autocomplete="off" class="NewTextBox" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
                  <i class="material-icons" *ngIf="!(this.Filter.SearchTerm?.length > 0) && !loadingShipment;">search</i>
                  <i class="material-icons" style="color:red;" *ngIf="this.Filter.SearchTerm?.length > 0 && !loadingShipment;" (click)="DeselectPartner();">close</i>
                
                  <div class="CentralSearchResultsContainer" *ngIf="Partners?.length > 0;">
                    <div *ngFor="let p of this.Partners;" class="PartnersSearchResultText" (click)="SelectPartner(p);">
                        {{p.Name}}
                    </div>
                  </div>
                </div>
    
                <div class="AddNewPartnerWhiteButton" (click)="ShowAddNewPartnerContainer();" *ngIf="this.Filter.SearchTerm?.length > 0 && (this.Partners?.length > 0) == false && (this.CurrentPartner?.ID != null) == false;">
                  <i class="material-icons">person_add_alt_1</i>
                </div>
            </div>
        </div>

        <div class="HalfContent" style="width: 45%;">
        </div>

        <div class="TransportSection" *ngIf="this.CurrentPartner?.ID != null;">
            <div class="ShippingCompanySelectContainer">
                <div class="ShippingCompany" *ngFor="let s of this.ShippingCompanies;let i = index;" (click)="SelectShippingCompany(s);" [ngClass]="{'SelectedShippingCompany': s.IsSelected == true}">
                    <div class="ShippingCompanyIcon">
                        <i class="material-icons" *ngIf="s.IsSelected == true;" style="color: #0082e6;">radio_button_on</i>
                        <i class="material-icons" *ngIf="s.IsSelected == false;">radio_button_off</i>
                    </div>
                    <div class="ShippingCompanyImage">
                        <img [src]="this.parent.BackendServiceUrl + s.ImagePath">
                    </div>
                </div>
            </div>
        </div>

        <div class="TransportSection" *ngIf="this?.ShippingCompany?.ShippingServiceTypes?.length > 0;">
            <div class="SectionTitle" style="margin-top: 0%;">
                {{'ShippingServices' | translate}}
            </div>
    
            <div class="SelectedOptionsContainer">
                <div *ngFor="let service of this.ShippingCompany.ShippingServiceTypes" class="SelectedOption" (click)="SelectShippingServiceType(service);">
                    <i class="material-icons" *ngIf="service.IsSelected == true;">check</i>
                    <i class="material-icons" *ngIf="service.IsSelected != true;" style="color: #fff;">check</i>
                    <span>{{service.Name}}</span>
                </div>
            </div>
        </div>
        
    </div>
</div>